import React from "react";
import { Link } from "react-router-dom";
import { SURFACE_STATUS, CLASSIC_SITE_BASE } from "../classicSite.constants";
import { buildDjangoAuthUrl } from "../auth/djangoOrigin";

const STATUS_LABELS = {
  [SURFACE_STATUS.DONE]: "Available",
  [SURFACE_STATUS.PARTIAL]: "Partial",
  [SURFACE_STATUS.SHELL]: "Shell",
  [SURFACE_STATUS.BLOCKED]: "Blocked",
  [SURFACE_STATUS.HYBRID]: "Hybrid (Django)",
  [SURFACE_STATUS.NA]: "N/A",
};

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {import('../classicSite.types').ClassicSiteSurfaceStatus} props.status
 * @param {string} props.djangoUrl
 * @param {string} props.reason
 * @param {string} [props.apiNote]
 * @param {string} [props.specRef]
 * @param {React.ReactNode} [props.children]
 */
export default function BlockedSurface({
  title,
  status,
  djangoUrl,
  reason,
  apiNote,
  specRef,
  children,
}) {
  const label = STATUS_LABELS[status] || status;

  return (
    <div className="cs-blocked">
      <div className="cs-blocked__header">
        <h2 className="cs-blocked__title">{title}</h2>
        <span className={`cs-badge cs-badge--${status}`}>{label}</span>
      </div>
      <p className="cs-blocked__reason">{reason}</p>
      {apiNote ? <p className="cs-blocked__note">{apiNote}</p> : null}
      {specRef ? (
        <p className="cs-blocked__spec">
          Spec: <code>{specRef}</code>
        </p>
      ) : null}
      {djangoUrl ? (
        <p className="cs-blocked__django">
          Django equivalent:{" "}
          <a href={djangoUrl} target="_blank" rel="noopener noreferrer">
            {djangoUrl}
          </a>
        </p>
      ) : null}
      {children}
    </div>
  );
}

export function HybridAuthLinks() {
  return (
    <div className="cs-hybrid-links">
      <Link to={`${CLASSIC_SITE_BASE}/member/auth`}>Auth overview</Link>
      {" · "}
      <Link to={`${CLASSIC_SITE_BASE}/login`}>Sign in</Link>
      {" · "}
      <a href={buildDjangoAuthUrl("/accounts/signup/")}>Django signup</a>
    </div>
  );
}
